import Swiper, {Navigation, Pagination} from 'swiper';
import 'swiper/css';
import 'swiper/css/bundle';
import animateText from '../components/animateText';
import { animate } from "../components/animateComponents";

import { checkTapit } from "../components/checkTapit";

export const page = async () => {
    checkTapit()
    animate();

    var swiper = new Swiper(".mySwiper", {
        slidesPerView: 3,
        spaceBetween: 90,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            // Cuando el ancho es >= 320px
            320: {
              slidesPerView: 1,
              spaceBetween: 20
            },
            // Cuando el ancho es >= 768px
            768: {
              slidesPerView: 2,
              spaceBetween: 30
            },
            // Cuando el ancho es >= 1024px
            1024: {
              slidesPerView: 3,
              spaceBetween: 30
            },
          },
        modules: [Navigation, Pagination],
    });
    
    var swiper2 = new Swiper(".mySwiper2", {
        pagination: {
            el: ".swiper-pagination2",
        },

        navigation: {
            nextEl: ".swiper-button-next2",
            prevEl: ".swiper-button-prev2",
        },
        modules: [Navigation, Pagination],
        on: {
            sliderFirstMove: () => {
                let refHand = document.querySelector('.handSwip')
                refHand?.classList.add('handSwip--hide')
            }
        }
    });

    new animateText("#quote")
    new animateText("#title")
    new animateText("#title4")
    new animateText("#description3")
    new animateText("#participa")
    new animateText("#participa-title")
    new animateText("#participa-description")
}